import React from 'react'
import { formatString } from '@cbgms/base/utils/helpers'

export interface IFullNameProps {
  title?: string
  initials?: string
  firstName: string
  prefix?: string
  lastName: string
}

const FullName: React.FC<IFullNameProps> = props => <React.Fragment>{BuildFullName(props)}</React.Fragment>

export default FullName

export function BuildFullName(props: IFullNameProps) {
  return formatString(props.title, props.initials || props.firstName, props.prefix, props.lastName)
}
